import { DeliveryOrderDto } from "@/api/portal"

export const doTypeMapping = {
  [DeliveryOrderDto.type.EXPORT]: "EXP",
  [DeliveryOrderDto.type.IMPORT]: "IMP",
  [DeliveryOrderDto.type.REPOSITION]: "REPO",
}
